import React from 'react'
import Typography from '../common/Typography/index'
import { Link } from 'react-router-dom'

const NotFound = () => {
  return (
    <div className="ml-[250px] mt-[50px] flex items-center justify-center w-[1040px] h-[500px] p-8">
      <div className="flex flex-col items-center justify-center text-center">
        <i className="fa-solid fa-circle-exclamation text-danger text-9xl" />
        <Typography className="text-5xl text-gray-700 text-center">Page Not Found</Typography>
        <Link to="/" className="text-blue-500 text-center text-2xl">
          Go Home
        </Link>
      </div>
    </div>
  )
}

export default NotFound
